import React from 'react';
import ReactDOM from 'react-dom';
import TreeView, { flattenTree } from "react-accessible-treeview";
import { FormControl, Button } from 'react-bootstrap';
import BatchSelector from './BatchSelector';

class ExtractedDataViewer extends React.Component {
    constructor(props, context) {
        super(props);
        this.id = 0;
        this.state = {
            siteId: null,
            pageSize: 15,
            extractedData: {},
            previousStartKeys: [],
            filter: '',
            dataCount: 0,
        };
        this.getAllExtractedData = this.getAllExtractedData.bind(this);
        this.refreshExtractedDataHandler = this.refreshExtractedDataHandler.bind(this);
        this.setSiteState = this.setSiteState.bind(this);
        this.filterRef = React.createRef();
        this.filterGeneralData = this.filterGeneralData.bind(this);
        this.batchChanged = this.batchChanged.bind(this);
    }

    batchChanged() {
            this.refreshExtractedDataHandler();
    }

    getTreeNode(key, item) {
        const node = {
            name: `${key}: ${item}`,
            children: [],
        };

        if (typeof item === 'object' && item !== null) {
            node.name = key;
            node.children = Object.entries(item).map(([childKey, childValue]) =>
                this.getTreeNode(childKey, childValue)
            );
        }

        return node;
    }

    transformDataToTreeView(inputData, tableKey) {
        let transformedSet = [];
    
        if (inputData && inputData.length > 0) {
            transformedSet = inputData.map((item) =>
                this.getTreeNode(item[tableKey] || `Attribute: ${tableKey} Not Found`, item)
            );
        }
    
        // Ensure the root node always has a valid children array or is set to null
        let rootNode = {
            name: 'Root Node',
            children: transformedSet.length > 0 ? transformedSet : []    // Use an empty array instead of null
        };
        return flattenTree(rootNode);
    }

    setSiteState(site_id) {
        this.setState({
            siteId: site_id,
        });
    }

    filterGeneralData() {
        const node = ReactDOM.findDOMNode(this.filterRef.current);
        this.setState({
            filter: node.value,
        });
        this.getExtractedData(undefined, undefined, undefined, node.value);
    }

    getExtractedData(direct = 'first', startKeyIndex = -1, filterTxt = null) {
        const batchId = this.props.batchId;
        const extractionId = this.props.currentExtraction?.id;
        const direction = direct || this.state.direction;
        const filter = filterTxt || this.state.filter;

        if (!batchId || !extractionId) return;

        const payload = {
            pageSize: this.state.pageSize,
            direction,
            startKey: '',
            previousStartKeys: [],
            filter,
        };

        if (this.state.previousStartKeys && this.state.previousStartKeys.length > 0) {
            payload.previousStartKeys = this.state.previousStartKeys;

            if (direction === 'backward' && startKeyIndex > 0) {
                payload.startKey = this.state.previousStartKeys[startKeyIndex];
                payload.previousStartKeys = this.state.previousStartKeys.slice(0, startKeyIndex + 2);
            } else if (direction === 'backward' && this.state.previousStartKeys.length > 1) {
                payload.startKey = this.state.previousStartKeys[this.state.previousStartKeys.length - 2];
            }
        }
        if (direction === 'forward') {
            payload.startKey = this.state.lastEvaluatedKey;
        }
        this.props.dataService.getExtractedData(batchId, extractionId, payload).then(res => {
            const tableKey = 'id';
            const treeData = this.transformDataToTreeView(res.data, tableKey);
            this.props.stateManagementService.updateExtractedData(treeData).then(() => {
                this.setState({
                    direction,
                    lastEvaluatedKey: res.last_evaluated_key,
                    previousStartKeys: res.previous_start_keys,
                    dataCount: res.data_count,
                });
            });
        });

    }

    refreshExtractedDataHandler(direction = 'first', startKeyIndex = -1) {
        this.getExtractedData(direction, startKeyIndex);
    }

    getAllExtractedData(direction, startKeyIndex = -1) {
        this.refreshExtractedDataHandler(direction, startKeyIndex);
    }

    render() {
        const { extractedData } = this.props;
        const treeData = extractedData;
        let pageIndex = 0;
        if (this.state.previousStartKeys && this.state.previousStartKeys.length > 0) {
            pageIndex = this.state.previousStartKeys.indexOf(this.state.lastEvaluatedKey) -1;
            pageIndex = pageIndex > -1 ? pageIndex : this.state.previousStartKeys.length -1;
        }
        const numRecords = Math.min(pageIndex * this.state.pageSize + this.state.pageSize, this.state.dataCount);
        return (
            <div>
                <div style={{ marginTop: '20px' }}>
                    <div className="row">
                        <div className="col-md-3">
                            <BatchSelector
                                batches={this.props.batches}
                                extraction={this.props.currentExtraction}
                                batchChanged={this.batchChanged}
                                stateManagementService={this.props.stateManagementService}
                                currentExtraction={this.props.currentExtraction}
                            />
                        </div>
                        <div className="col-md-7">
                            <FormControl
                                ref={this.filterRef}
                                autoFocus
                                placeholder="Enter a unique ID for a specific record"
                            />
                        </div>
                        <div className="col-md-2">
                            <Button
                                className="btn btn-primary mb-2 pull-left"
                                onClick={this.filterGeneralData}
                            >
                                Filter
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <span>
                            {this.state.dataCount > 0 ? (
                                `Records ${pageIndex * this.state.pageSize + 1} - ${numRecords} of ${this.state.dataCount}`
                            ) : (
                                ''
                            )}
                        </span>
                    </div>
                </div>
                <div style={{ marginTop: '20px' }}>
                    {treeData && treeData.length > 0 && treeData[0].children.length > 0 ? (
                        <TreeView
                            data={treeData}
                            aria-label="Extracted Data Tree"
                            togglable="true"
                            nodeRenderer={({ element, isBranch, isExpanded, getNodeProps }) => (
                                <div {...getNodeProps()}>
                                    {isBranch && (isExpanded ? '▼ ' : '▶ ')}
                                    {element.name}
                                </div>
                            )}
                        />
                    ) : (
                        this.props.batchId ?
                        <p>No data available</p>
                        :
                        <p>Please select a batch</p>
                    )}
                </div>

                <div style={{ marginTop: '20px', display: 'flex', gap: '8px' }} className="col-md-12">
                    {treeData && treeData.length > 0 && treeData[0].children.length > 0 && (
                        <Button
                            variant="light"
                            onClick={() => this.getAllExtractedData('first')}
                        >
                            1
                        </Button>
                    )}
                    {treeData && treeData.length > 0 && treeData[0].children.length > 0 && 
                        this.state.previousStartKeys &&
                        this.state.previousStartKeys.map((_item, index) =>
                            index === 0 || index === this.state.previousStartKeys.length - 1 ? null : (
                                <Button
                                    key={index}
                                    variant="light"
                                    onClick={() => this.getAllExtractedData('backward', index)}
                                >
                                    {index + 1}
                                </Button>
                            )
                        )}
                    {treeData && treeData.length > 0 && treeData[0].children.length > 0 && 
                    this.state.previousStartKeys && this.state.previousStartKeys.length > 1 && (
                        <Button
                            variant="light"
                            onClick={() => this.getAllExtractedData('backward')}
                        >
                            Prev
                        </Button>
                    )}
                    {treeData && treeData.length > 0 && treeData[0].children.length > 0 && 
                    this.state.lastEvaluatedKey !== '{}' && (
                        <Button
                            variant="light"
                            onClick={() => this.getAllExtractedData('forward')}
                        >
                            Next
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

export default ExtractedDataViewer;